module.exports = __webpack_public_path__ + "static/media/dinner6.47c77dd1.png";